import {
  SET_LABELLING_FLOW_DATA,
  SET_TOOL_CONTEXT_MENU_DATA,
  RESET_LABELLING_AND_CONTEXT_MENU,
  SET_IMAGE_CONTEXT_DATA,
  RESET_IMAGE_CONTEXT_DATA,
  SET_HEATMAP_CONTEXT_DATA,
} from './actionTypes';

const defaultState = {
  labelling: {},
  contextMenu: {},
  imageData: {},
  heatmapContext: {
    activeId: 'tuberculosis',
    opacity: 100,
  },
};

const ui = (state = defaultState, action) => {
  switch (action.type) {
    case SET_LABELLING_FLOW_DATA: {
      const labelling = Object.assign({}, action.labellingFlowData);

      return Object.assign({}, state, { labelling });
    }
    case SET_TOOL_CONTEXT_MENU_DATA: {
      const contextMenu = Object.assign({}, state.contextMenu);

      contextMenu[action.viewportIndex] = Object.assign(
        {},
        action.toolContextMenuData
      );

      return Object.assign({}, state, { contextMenu });
    }
    case RESET_LABELLING_AND_CONTEXT_MENU:
      return Object.assign({}, state, {
        labelling: defaultState.labelling,
        contextMenu: defaultState.contextMenu,
      });
    case SET_IMAGE_CONTEXT_DATA: {
      const imageData = Object.assign({}, state.imageData);
      imageData[action.viewportIndex] = Object.assign({}, action.eventData);
      return { ...state, imageData };
    }
    case RESET_IMAGE_CONTEXT_DATA:
      return { ...state, imageData: defaultState.imageData };
    case SET_HEATMAP_CONTEXT_DATA:
      return { ...state, heatmapContext: { ...action.data } };
    default:
      return state;
  }
};

export default ui;
